import { IssueFieldEnum } from "@mcapps/shared/enums";
import { IIssueBoardApi } from "@mcapps/shared";
import React from "react";
import { FailedAlert } from "../../../../components";
import { usePutProjectByProjectIdIssueboardAndBoardIdDisabledColumnsMutation } from "../../../../../openapi";

import { getIssueActionNameOption } from "../issueUtils";
import DisabledIssueColumns from "./DisableIssueColumns";
import SettingsCardWrapper from "./SettingsCardWrapper";

const IssueColumnSettingsTasks: React.FC<{ issueBoard: IIssueBoardApi }> = ({ issueBoard }) => {
  const [updateBoards, { isLoading: updateBoardsLoading, error: updateBoardsError }] =
    usePutProjectByProjectIdIssueboardAndBoardIdDisabledColumnsMutation();

  const [editMode, setEditMode] = React.useState(false);

  const baseColumns: IssueFieldEnum[] = [
    IssueFieldEnum.ASSIGNEDTO_NAME,
    IssueFieldEnum.STATUS,
    IssueFieldEnum.DATES_DUE,
    IssueFieldEnum.DATES_COMPLETED,
  ];

  const customAttributeFields = Object.values(issueBoard?.otherAttributesTasksConfig ?? {})
    .map((attr) => attr.label)
    .filter(Boolean);

  const columnsTobeDisabled = [...baseColumns, ...customAttributeFields];

  return (
    <SettingsCardWrapper
      title={`Deaktiverte kolonner for ${getIssueActionNameOption(
        issueBoard?.taskNameSetting,
        "plural",
      ).toLocaleLowerCase()} i tabellvisning`}
    >
      {updateBoardsError != null && <FailedAlert />}
      <DisabledIssueColumns
        updateBoards={(disabledColumnsTasks) =>
          updateBoards({
            projectId: issueBoard.project,
            boardId: issueBoard._id,
            body: {
              disabledColumns: disabledColumnsTasks,
              taskOrIssue: "TASK",
            },
          })
        }
        board={issueBoard}
        isEditable
        editMode={editMode}
        editCb={(bool) => setEditMode(bool)}
        columnsTobeDisabled={columnsTobeDisabled}
        taskOrIssue="TASK"
      />
    </SettingsCardWrapper>
  );
};

export default IssueColumnSettingsTasks;
